import React from 'react';
import {
  // Form,
  // Select,
  // DatePicker,
  Row,
  Col
  // Typography,
  // Checkbox,
  // Input,
  // Button,
  // Divider,
  // Tabs,
  // Card
} from 'antd';
import styles from './styles.module.less';

const Contact = ({ user_data }) => {
  // const profileData =
  //   Array.isArray(profiles) && profiles.length > 0
  //     ? profiles[0]
  //     : profiles || {};

  // console.log('profileData', user_data?.phone_number);
  console.log(
    'user_data?.Country?.country_code',
    user_data?.phone_1_code?.country_code
  );
  // const contact_number = user_data?.phone_number
  //   ? `${user_data?.phone_1_code?.country_code} ${user_data?.phone_number}`
  //   : 'N/A';
  const contact_number =
    user_data?.phone_number && user_data?.phone_1_code?.country_code
      ? `${user_data.phone_1_code.country_code} ${user_data.phone_number}`
      : user_data?.phone_number
      ? user_data.phone_number
      : 'Not provided';
  // const country_code = user_data?.Country?.country_code || 'N/A';
  const email = user_data?.email || 'Not provided';
  // const alternate_contact_number = user_data?.phone_number_2
  //   ? `${user_data?.phone_2_code?.country_code} ${user_data?.phone_number_2}`
  //   : 'N/A';
  const alternate_contact_number =
    user_data?.phone_number_2 && user_data?.phone_2_code?.country_code
      ? `${user_data.phone_2_code.country_code} ${user_data.phone_number_2}`
      : user_data?.phone_number_2
      ? user_data.phone_number_2
      : 'Not provided';
  const address = user_data?.address || 'Not provided';

  // console.log('contact_number', alternate_contact_number);
  return (
    <>
      <div className={styles.horoscopestyles}>
        <Row gutter={24} className={styles.phone}>
          <Col span={8} className={styles.colStyle}>
            <span className={styles.first}>Phone Number</span>
            <span className={styles.second}> {contact_number} </span>
          </Col>
          <Col span={8} className={styles.colStyle}>
            <span className={styles.first}>Alternate Number</span>
            <span className={styles.second}> {alternate_contact_number} </span>
          </Col>
          <Col span={8} className={styles.colStyle}>
            <span className={styles.firstrow}>Email</span>
            <span className={styles.second}> {email} </span>
          </Col>
        </Row>
        <Row gutter={24} style={{ paddingTop: '17px', color: '#d20b0b' }}>
          <Col className={styles.colStyle}>
            <span className={styles.firstrow}>Address</span>
            <span className={styles.second}> {address} </span>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Contact;
